import { Fragment } from "react/jsx-runtime";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { PopoverTitle, UIKits } from "../../../Constants/Constants";
import BasicPopover from "./BasicPopover";
import PopoverDirection from "./PopoverDirection";
import PopoverOffset from "./PopoverOffset/PopoverOffset";
import DisabledElements from "./DisabledElements";
import DelayPopover from "./DelayPopover";
import DismissPopover from "./DismissPopover";

const PopoverContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={PopoverTitle} parent={UIKits} />
      <Container fluid>
        <Row className="popover-main">
          <BasicPopover />
          <DisabledElements />
          <DelayPopover />
          <DismissPopover />
          <PopoverDirection />
          <PopoverOffset />
        </Row>
      </Container>
    </Fragment>
  );
};
export default PopoverContainer;
